import { useMemo } from 'react';
import { ERoleNames } from '../ducks/api-ducks/app-config-duck/types-app-config';
import { useAppSelector } from '../ducks/hooks';

export const useIsImpersonating = () => {
  const isImpersonating = useAppSelector((state) => state.impersonation.isImpersonating);
  return isImpersonating;
};

export const useIsBusinessImpersonating = () => {
  const appConfig = useAppSelector((state) => state.appConfig);
  const impersonation = useAppSelector((state) => state.impersonation);
  return useMemo(() => {
    let show = false;

    // If appConfig is not ready yet, then don't show
    if (!appConfig) {
      return false;
    }
    // If appConfig.isBusinessPersona is true, then show
    if (
      appConfig?.isBusinessPersona &&
      (appConfig?.businessPersonaRoleName === ERoleNames.BusinessAdmin || appConfig?.businessPersonaRoleName === ERoleNames.OperationsSupport) &&
      impersonation?.isImpersonating
    ) {
      show = true;
    } else {
      return false;
    }
    return show;
  }, [appConfig, impersonation?.isImpersonating]);
};
